import { EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import Global from '../../store/global-selectors';

import * as PrintSettingsActions from './print-settings.actions';
import { writePrintSettings, writePrintWarningSettings } from '../../pages/settings/printing/print-settings-storage-manager';

export const writePrintSettingsToLocalStorage = (action$, { getState }) => {
  return action$.pipe(
    ofType(
      PrintSettingsActions.SAVE_PRINT_SETTINGS,
      PrintSettingsActions.RESTORE_PRINT_SETTINGS_SUCCESS,
      PrintSettingsActions.CLEAR_ALL_SETTINGS_WITH_WORKSTATION,
    ),
    mergeMap(() => {
      const currentSettings = Global.selectPrintSettingsPrintSettings(getState());
      writePrintSettings(currentSettings);
      return EMPTY;
    }),
  );
};

export const writePrintWarningSettingsToLocalStorage = (action$, { getState }) => {
  return action$.pipe(
    ofType(PrintSettingsActions.SAVE_PRINT_WARNING_SETTINGS),
    mergeMap(() => {
      const currentWarningSettings = Global.selectPrintSettingsPrintWarningSettings(getState());
      writePrintWarningSettings(currentWarningSettings);
      return EMPTY;
    }),
  );
};
